export default{
    name:'login',
    data(){
        return {
            logining: false,
            LoginName:'',
            Password:'',
            rules2: {
                LoginName: [
                  { required: true, message: '请输入账号', trigger: 'blur' },
                  //{ validator: validaePass }
                ],
                Password: [
                  { required: true, message: '请输入密码', trigger: 'blur' },
                  //{ validator: validaePass2 }
                ]
              },
              checked: true
        }
    },
    mounted: function () {
        var me = this;
        me.loadLoginSetting();
    },
    methods:{
        loadLoginSetting()
        {
        },
        focusPwd(){
            this.$refs.Password.focus();
        },
        loginMethod(isAdmin) {
    
            var me = this;
            
            this.logining = true;

            var usercode = this.LoginName;
            var password = this.Password;
            
            if (usercode == null || usercode == "" ) {
                me.alert('请输入账户','通知');
                this.logining = false;
                return;
            }

            if ( password == null || password == "") {
                me.alert('请输入密码','通知');
                this.logining = false;
                return;
            }
            
            var loginMethod = 'LoginIn/Login'
            this.$axios.get(loginMethod,
                {
                    params:{
                        loginname:usercode,
                        password:password,
                    }
                })
            .then((response) => {
                this.logining = false;
                if (true)//response.status == 200) 
                {
                    if(response.data.IsSuccess)
                    {
                        /*将当前用户和Token写入缓存*/
                        sessionStorage.setItem('user', JSON.stringify(response.data.Data));

                        this.$router.push({ path: '/Home' });
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
            }); 
        },

    }

}


// WEBPACK FOOTER //
// ./src/components/Login/Login.js